import { Component, EventEmitter, Input, Output } from '@angular/core';

export enum AlertType {
  error,
  info,
  warning
}

@Component({
  selector: 'sita-alerts',
  standalone: false,
  templateUrl: './alerts.component.html',
  styleUrl: './alerts.component.scss'
})
export class AlertsComponent {
  @Input() message : string = '';
  @Input() alertType: string = '';

  @Output() close = new EventEmitter();

  showAlert = true;

  closeAlert(){
    this.showAlert = false;
    this.close.emit('close');
  }
}
